import { BuildTemplatesUrlParams, PATHS, TEMPLATES_TAB } from '@/shared/config';

export const buildTemplatesUrl = (
  params: BuildTemplatesUrlParams = {},
): string => {
  const search = new URLSearchParams({ tab: TEMPLATES_TAB });

  if (params.specialty) {
    search.set('specialty', params.specialty);
  }

  if (params.editor) {
    search.set('editor', params.editor);
  }

  if (params.mode) {
    search.set('mode', params.mode);
  }

  if (params.id) {
    search.set('id', params.id);
  }

  if (params.importedTemplateSeriesId) {
    search.set('imported_template_series_id', params.importedTemplateSeriesId);
  }

  return `${PATHS.companySettings}?${search.toString()}`;
};
